/**
 * 返回值Code值
 */
export enum ResultCodeEnum {
  /**
   * 成功
   */
  Success = 0,
  /**
   * 错误
   */
  Error = -1
}

/**
* 颜色枚举
*/
export enum ColorEnum {
  /**
   * 成功
   */
  "Success" = "#63e2b7",
  /**
   * 提示
   */
  "Info" = "#70c0e8",
  /**
   * 警告
   */
  "Warning" = "#f2c97d",
  /**
   * 错误
   */
  "Error" = "#e88080"
}


/**
 * 账号类型
 */
export enum AccountTypeEnum {
  /**
   * 账号类型
   */
  None = 0,
  /**
   * 正常账号
   */
  Normal = 1,
  /**
   * 测试账号
   */
  Test = 2
}


/**
状态
  pending	待审核	用户发起提现后默认状态
  approved	审核通过	管理员审核通过，待打款
  paid	已打款	已成功转账/到账
  rejected	已拒绝	审核不通过
  cancelled	已取消	用户主动取消
 */
export enum WithdrawStatusEnum {
  /** 待审核 */
  pending = "Pending Review",

  /** 审核通过 */
  approved = "Approved",

  /** 已打款 */
  paid = "Paid",

  /** 已拒绝 */
  rejected = "Rejected",

  /** 已取消 */
  cancelled = "Cancelled"
}


/**
 * AI订单方向
 */
export enum AiOrderDirectionEnum {
  /** 无 */
  none = "None",

  /** 涨 */
  up = "Up",

  /** 跌 */
  down = "Down"
}


export enum ControlResultEnum {
  /** 未知 */
  none = "Unknown",

  /** 盈利 */
  profit = "Profit",

  /** 亏损 */
  loss = "Loss"
}


/**
 * 生效状态
 */
export enum AiEffectStatusEnum {
  /** 无 */
  none = "None",

  /** 待生效 */
  pending = "Pending",

  /** 已生效 */
  active = "Active"
}


/**
 * AI来源
 */
export enum AiSourceEnum {
  /** 无 */
  none = "None",

  /** 用户 */
  user = "User",

  /** 系统 */
  system = "System"
}

/**
 * 控结果
 */
export enum AiControlResultEnum {
  /** 未知 */
  none = "Unknown",

  /** 盈利 */
  profit = "Profit",

  /** 亏损 */
  loss = "Loss"
}


/**
 * 交易状态
    open     持仓中
    closed   已平仓
    liquidated 强平
 */
export enum FuturesTradeRecordStatusEnum {
  /** 持仓中 */
  none = "Open Position",

  /** 等待(委托中) */
  pending = "Pending (Entrusted)",

  /** 持仓中 */
  open = "Open Position",

  /** 已平仓 */
  closed = "Closed Position",

  /** 强平 */
  liquidated = "Liquidated"
}


/**
  平仓类型
    manual     手动
    auto       止盈止损
    system     系统强平
 */
export enum FuturesTradeRecordCloseTypeEnum {
  /** 未知 */
  none = "Unknown",

  /** 手动 */
  manual = "Manual",

  /** 自动 */
  auto = "Automatic",

  /** 系统强平 */
  system = "System Liquidation"
}


/**
 * 结算状态枚举
 */
export enum SettlementStatusTypeEnum {
  /** 待结算 */
  unsettled = "Unsettled",

  /** 已结算 */
  settled = "Settled"
}


/**
 * 时效类型
 */
export enum DurationTypeEnum {
  /** 点位 */
  point = "Point",

  /** 秒 */
  second = "Second"
}

/**
 * 操作方式
 */
export enum OperationTypeEnum {
  /** 未知 */
  none = "Unknown",

  /** 手动 */
  manual = "Manual",

  /** AI */
  ai = "AI"
}

/**
 * 贷款申请数据状态枚举
 */
export enum LoanApplactionStatusEnum {
  /**
   * 待提交
   */
  PendingSubmission = 0,
  /**
   * 审核中
   */
  UnderReview = 1,
  /**
   * 已通过
   */
  Approved = 2,
  /**
   * 已拒绝
   */
  Rejected = 3,
  /**
   * 已结清
   */
  Settled = 4
}